import { AppThunk } from 'store';
import dataServices from 'dataServices';
import { batch } from 'react-redux';
import { StatusLoading } from 'common/constants';
import { defaultBBox } from 'common/utils';
import { getResponseError, handleApiErrors } from 'common/utils/index';
import { getArrayToObject } from 'common/utils/directionsService/utils';

import slice from '../reducer/slice';
import appSlice from '../../application/reducer/slice';
import directoriesSlice from '../../directories/reducer/slice';
import { IStationFilter } from '../types/stationFilter';
import {
  mappingStations,
  MappingStationResult,
  mappingStationCodes,
} from '../utils';
import { STATE as FUEL_CARDS_STATE } from '../../fuelCards/types';

const {
  setAllStations,
  setIsLoadingAllStations,
  setStations,
  setActionStations,
  setActionStationsFitBounds,
  setStationsFitBounds,
  setFilter,
} = slice.actions;
const { setError } = appSlice.actions;
const { updateRoadsideServices } = directoriesSlice.actions;

const operation =
  (urlFilter?: IStationFilter, isSetBounds: boolean = true): AppThunk =>
  async (dispatch, getState) => {
    try {
      dispatch(setIsLoadingAllStations(StatusLoading.Load));
      let mappedData: MappingStationResult | null = null;
      const state = getState();
      const { activeFuelCard } = state[FUEL_CARDS_STATE].fuelCards;

      const [{ value: allStationsResponse }, { value: stationCodesResponse }] =
        await dataServices.stations.initStations({
          urlFilter: { ...urlFilter, fullCardNumber: activeFuelCard },
          fullCardNumber: activeFuelCard,
        });

      // Handle errors from allStations response
      handleApiErrors(allStationsResponse?.errors, dispatch, setError);

      // Handle errors from stationCodes response
      handleApiErrors(stationCodesResponse?.errors, dispatch, setError);

      const allStations = allStationsResponse?.stations || [];
      const stationCodes = stationCodesResponse?.stations;

      if (stationCodes && stationCodes.length > 0) {
        mappedData = await mappingStationCodes(stationCodes, allStations);
      } else {
        mappedData = await mappingStations(allStations);
      }

      const prevServiceCodes = Object.keys(urlFilter?.roadsideServices || {});

      const roadsideServices = mappedData?.serviceCodes?.length
        ? getArrayToObject(
            mappedData.serviceCodes.filter((code) =>
              prevServiceCodes.includes(`${code}`),
            ),
          )
        : urlFilter?.roadsideServices;

      batch(() => {
        dispatch(setIsLoadingAllStations(StatusLoading.Done));
        dispatch(setAllStations(allStations));
        if (isSetBounds) {
          const latLngBounds =
            urlFilter && mappedData ? mappedData.stationsBBox : defaultBBox;
          dispatch(setStationsFitBounds(latLngBounds));
        }
        if (urlFilter) {
          dispatch(
            setFilter({
              ...urlFilter,
              roadsideServices,
            }),
          );
        }

        if (mappedData?.serviceCodes) {
          dispatch(
            updateRoadsideServices({
              roadsideServiceKeys: mappedData.serviceCodes,
            }),
          );
          dispatch(setActionStationsFitBounds(mappedData.actionStationsBBox));
          dispatch(setStations(mappedData.stations));
          dispatch(setActionStations(mappedData.actionStations));
        }
      });
    } catch (e) {
      console.info('e: ', e);
      const error = await getResponseError(e);
      batch(() => {
        dispatch(setError(error));
        dispatch(setIsLoadingAllStations(StatusLoading.Error));
      });
    }
  };

export default operation;
